import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import IncomeLeft from '../../component/income-left';
import IncomeRight from '../../component/income-right';
import moHumanIndustry from '../store/industry';
import Empty from '@/component/empty';

interface IProps {
  activeTab: string
}
interface IState { }

const IndustryIncomeChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industryList } = moHumanIndustry;
  const { activeTab } = props;

  const emen: any = {
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    人均薪酬成本: 'cost_per_staff',
    元均营业收入: 'revenue_per_yuan',
    元均净利润: 'profit_per_yuan',
  };

  const xData = useMemo(() => {
    const active = emen[activeTab];
    const xList: any = [];
    const list: any = [];
    const rate: any = [];
    if (industryList) {
      industryList[active]?.detail?.forEach((res: any) => {
        xList.unshift(res.label);
        list.unshift((activeTab === '元均营业收入' || activeTab === '元均净利润') ? round(res.p50, 1) : round(res.p50, 0));
        rate.unshift(res.p50_ratio);
      });
    }
    return {
      xList, list, rate,
    };
  }, [industryList, activeTab]);

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="industry-income-warp-pdf">
      {xData?.list?.filter((res: any) => res).length > 0 ? <section className='left-chart'>
        <section className='title'>{activeTab}{(activeTab === '元均营业收入' || activeTab === '元均净利润') ? '' : '（元）'}</section>
        <IncomeLeft height={300} xData={xData?.list}
          yData={xData.xList} />
      </section> : <Empty />}
      {xData?.rate?.filter((res: any) => res).length > 0 ? <section className='right-chart'>
        <section className='title'>变化率（%）</section>
        <IncomeRight height={300} yData={xData?.xList}
          xData={xData.rate} />
      </section> : <Empty />}
    </section>
  );
};

export default observer(IndustryIncomeChart);
